import { Button, Flex, Stack } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormSection } from '@/containers/forms/FormSection'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { InformationForm } from '../forms/InformationForm'

export const Information = ({
  onContinue,
  onSave,
  isLoading,
  number = 3
}: {
  onContinue: () => Promise<any>,
  onSave: () => Promise<any>
  isLoading: boolean,
  number?: number
}) => {
  const { app } = useApp()
  const isPublicPoleas = app === Apps.publicPoleas
  const { formState: { errors }, getValues, watch } = useFormContext<InsuranceParamsDto>()

  const isJapPoleasing = !!getValues('importedData')
  const { isDisabled } = useInsuranceParams()
  const paramsDataValid = watch('generalParams.paramsDataValid')

  return (
    <FormSection number={number} sectionTitle="Obecné informace"
      footer={isDisabled ? undefined :
        <Stack direction='column' w='100%'>
          <Flex sx={{ w: '100%', justifyContent: 'center' }} gap={4}>
            {isJapPoleasing && (!isPublicPoleas || paramsDataValid === false) &&
              <Button
                type="button"
                variant="solid"
                isLoading={isLoading}
                onClick={onSave}
              >
                Uložit
              </Button>
            }

            {(!isPublicPoleas || paramsDataValid === true) && <Button
              type="button"
              variant="solid"
              isLoading={isLoading}
              colorScheme="green"
              onClick={onContinue}
            >
              Pokračovat
            </Button>}
          </Flex>
        </Stack>
      }
    >
      <InformationForm />
    </FormSection>
  )
}
